import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Technical telemetry for failed API calls (no payloads, no PII). Never blocks the app.
api.interceptors.request.use((cfg) => { cfg.metadata = { start: Date.now() }; return cfg; });
api.interceptors.response.use(
  (res) => res,
  (err) => {
    try {
      const cfg = err?.config || {};
      if (!String(cfg.url || "").includes("/tech/events")) {
        import("./tech").then(({ reportApiFailure }) => reportApiFailure({
          url: cfg.url, method: cfg.method, status: err?.response?.status,
          durationMs: cfg.metadata ? Date.now() - cfg.metadata.start : undefined,
          code: err?.response?.data?.detail?.code || err.code,
          message: err?.message,
        })).catch(() => {});
      }
    } catch { /* no-op */ }
    return Promise.reject(err);
  },
);

export function wsURL() {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/ws`;
}

// Belgrade-local order date/time. SR: "10.09.2026. · 18:41" · EN: "10 Sep 2026 · 18:41".
export const fmtDateTime = (iso, locale = "sr", withTime = true) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const tz = "Europe/Belgrade";
  let date;
  if (locale === "en") {
    date = new Intl.DateTimeFormat("en-GB", { day: "2-digit", month: "short", year: "numeric", timeZone: tz }).format(d);
  } else {
    date = new Intl.DateTimeFormat("sr-RS", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: tz }).format(d).replace(/\s/g, "") + ".";
  }
  if (!withTime) return date;
  const time = new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: tz }).format(d);
  return `${date} · ${time}`;
};

export const RSD = (n) =>
  new Intl.NumberFormat("sr-RS").format(Math.round(Number(n) || 0)) + " RSD";

// Resolve stored image values: our own storage paths ("/api/files/..") get the
// backend prefix; external/absolute URLs pass through unchanged.
export const imgURL = (v) => {
  if (!v) return "";
  if (/^(https?:|data:|blob:)/i.test(v)) return v;
  if (v.startsWith("/")) return `${BACKEND_URL}${v}`;
  return v;
};
